import BookingService from "../bookings/BookingService";
import dragon_common from "assets/img/illustrations/achievements/dragon-common.jpeg";
import dragon_uncommon from "assets/img/illustrations/achievements/dragon-uncommon.jpeg";

const AchievementService = {
  async saveAthleteAchievement(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      let url =
        '/api/wod/achievement/' +
        formData.achievement.value +
        '/athlete/' +
        profileLogged.identifier;
      let method = 'POST';

      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {
        url =
          '/api/wod/achievement/' +
          formData.achievement.value +
          '/athlete/' +
          profileLogged.identifier;
        method = 'PUT';
      }
      const updatedData = {
        ...formData,
        profileIdentifier: profileLogged.identifier,
        achievementIdentifier: formData.achievement.value
      };
      console.log('Updated Data', updatedData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newAchievement = await response.json();
        console.log('Achievement has been updated:', newAchievement);
      }
    } catch (error) {
      console.log('Error saving Achievement', error);
    }
  },
  async retrieveAllAchievementByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      const response = await fetch(
        '/api/wod/achievement/account/' + accountIdentifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Achievement', error);
      throw error;
    }
  },
  async retrieveInProgressByProfile() {
    const { identifier } = JSON.parse(localStorage.getItem('profile'));

    const bookings = await BookingService.retrieveAllBookingsByUser(identifier);
    const totalBookings = bookings.length;
    try {
      const method = 'GET';
      let url = '/api/wod/achievement/type/progress';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const achievements = await response.json();
        const updatedData = achievements.map(a => ({
          id: a.identifier,
          name: a.name,
          icon: '🔒',
          description: a.description,
          progress: totalBookings / a.goal,
          rarity: a.level
        }));

        return updatedData;
      }
    } catch (error) {
      console.log('Error saving Achievement', error);
    }
  },
  async retrieveUnlockedByProfile() {
    try {
      const method = 'GET';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      let url =
        '/api/wod/achievement/unlocked/true/athlete/' +
        profileLogged.identifier;
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const athleteAchievements = await response.json();
        url = '/api/wod/achievement/account/' + profileLogged.accountIdentifier;
        const responseAchievements = await fetch(url, {
          method: method,
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const achievements = await responseAchievements.json();
        const updatedData = athleteAchievements.map(aa => {
          const achievement = achievements.find(
            a => a.identifier === aa.achievementIdentifier
          );
          return {
            ...aa,
            name: achievement?.name,
            description: achievement?.description,
            rarity: achievement?.level,
            unlockedDate: aa.date,
            icon: '💪',
            img: achievement?.level === 'uncommon' ? dragon_uncommon : dragon_common,
            id: aa.identifier
          };
        });
        return updatedData;
      }
    } catch (error) {
      console.log('Error saving Achievement', error);
    }
  },
  async retrieveAchievement(identifier) {
    try {
      const response = await fetch('/api/<your_controller>/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Achievement', error);
      throw error;
    }
  },
  async deleteAchievement(identifier) {
    try {
      let url = '/api/<your_controller>';
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        const newAchievement = await response.json();
        console.log('Achievement has been deleted:', newAchievement);
      }
    } catch (error) {
      console.log('Error deleting Achievement', error);
    }
  }
};
export default AchievementService;
